import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';

export class NgxBootstrapDropdownConfigService {

    static getBsDropdownConfig(): BsDropdownConfig {
        return Object.assign(new BsDropdownConfig(), {
        });
    }
}
